const getDefaultState = () => {
  return {
    customerName: '',
    customerPhoneNumber: '',
    customerEmail: '',
    customerBirth: '',
    customerGender: '',
    customerMemo: ''
  }
}
const state = getDefaultState()

const getters = {
  customer: (state) => {
    return {
      name: state.customerName,
      phoneNumber: state.customerPhoneNumber,
      email: state.customerEmail,
      birth: state.customerBirth,
      gender: state.customerGender,
      memo: state.customerMemo
    }
  },
  customerName: (state) => {
    return state.customerName
  },
  customerPhoneNumber: (state) => {
    return state.customerPhoneNumber
  },
  customerEmail: (state) => {
    return state.customerEmail
  },
  customerBirth: (state) => {
    return state.customerBirth
  },
  customerGender: (state) => {
    return state.customerGender
  },
  customerMemo: (state) => {
    return state.customerMemo
  }
}

const actions = {
}

const mutations = {
  resetCustomer (state) {
    Object.assign(state, getDefaultState())
  },
  changeCustomerName (state, name) {
    state.customerName = name
  },
  changeCustomerPhoneNumber (state, phoneNumber) {
    state.customerPhoneNumber = phoneNumber
  },
  changeCustomerEmail (state, email) {
    state.customerEmail = email
  },
  changeCustomerBirth (state, birth) {
    state.customerBirth = birth
  },
  changeCustomerGender (state, gender) {
    state.customerGender = gender
  },
  changeCustomerMemo (state, memo) {
    state.customerMemo = memo
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/customer/index.js